import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import ExternalHtml from 'common/services/html-content/external-html'

export default class HeroSection extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    titleSlug: PropTypes.string,
    subtitle: PropTypes.string,
    subtitleSlug: PropTypes.string,
    className: PropTypes.string,
    extraContent: PropTypes.element,
  }

  get subtitlePresent() {
    return this.props.subtitle || this.props.subtitleSlug
  }

  renderSubtitle() {
    if (!this.subtitlePresent) {
      return null
    }

    const { subtitle, subtitleSlug } = this.props
    return (
      <div className="page-subtitle">
        {subtitleSlug ? <ExternalHtml hideLoader slug={subtitleSlug} /> : subtitle}
      </div>
    )
  }

  render() {
    const { title, titleSlug, className, extraContent } = this.props
    return (
      <div className={cn(className, 'hero-section')}>
        <div className="grid-container">
          <div className="grid-x grid-padding-x">
            <div className="small-12 medium-12 large-8 cell">
              <h1 className={cn('page-title', { 'margin-bottom-0': !this.subtitlePresent })}>
                {titleSlug ? <ExternalHtml slug={titleSlug} /> : title}
              </h1>
              {this.renderSubtitle()}
              {extraContent}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
